import React from "react";

function Icon({ color, viewBox = "0 0 24 24", className = "hayley-h-6 hayley-w-6 hayley-text-custom-10" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox={viewBox} fill="none" className={className}>
      <path fill={color || "currentColor"} d="M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"></path>
    </svg>
  );
}

export default Icon;
